var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBglSimpleFund360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0089BF",
    d: "M3.585 26.088c.262.32.535.626.819.92a15.985 15.985 0 0 0 3.031 2.504l.056.037 11.176-11.176a3.517 3.517 0 0 0 .451-4.063c-.311-.56-.822-.937-.94-1.593a1.963 1.963 0 0 1 .482-1.683l.136-.134c.362-.331.835-.514 1.326-.513 1.273 0 2.095 1.323 2.594 2.35.128.265.241.538.34.816a7.417 7.417 0 0 1 .406 2.437c0 .733-.107 1.463-.32 2.165a7.382 7.382 0 0 1-1.503 2.717c-.56.631-10.393 10.39-10.393 10.39 3.1.957 6.418.957 9.518 0a15.841 15.841 0 0 0 3.806-1.761 16.17 16.17 0 0 0 4.958-4.955 15.942 15.942 0 0 0 2.476-8.556c0-.891-.074-1.78-.224-2.659a14.916 14.916 0 0 0-.497-2.103c-.41-1.32-.991-2.58-1.727-3.75l-.034-.058a17.263 17.263 0 0 0-1.063-1.475l-.061-.073-.04-.05c-.221-.267-.451-.53-.692-.783a15.454 15.454 0 0 0-3.085-2.552L13.364 13.704a3.526 3.526 0 0 0-.732 3.332c.134.43.352.83.64 1.177.033.034.204.242.21.247.118.164.213.345.28.536.065.2.098.407.098.617a1.977 1.977 0 0 1-1.963 1.963 2.18 2.18 0 0 1-1.73-.979 6.262 6.262 0 0 1-.438-.614 7.38 7.38 0 0 1-.85-1.77 7.456 7.456 0 0 1-.333-2.22 7.426 7.426 0 0 1 1.607-4.622C11.05 10.249 20.809.715 20.809.715A16.013 16.013 0 0 0 3.585 26.088Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBglSimpleFund360);
export default __webpack_public_path__ + "static/media/bglSimpleFund360.7bf67b551c910fe855b349cc77ecd858.svg";
export { ForwardRef as ReactComponent };